import { render, staticRenderFns } from "./DressBrandLog.vue?vue&type=template&id=d1862bb0&scoped=true"
import script from "./DressBrandLog.vue?vue&type=script&lang=js"
export * from "./DressBrandLog.vue?vue&type=script&lang=js"
import style0 from "./DressBrandLog.vue?vue&type=style&index=0&id=d1862bb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1862bb0",
  null
  
)

export default component.exports